export default __webpack_public_path__ + "static/media/dollar-green.4cd79159.png";